// billingPageRoute

import React, { Component, lazy, Suspense } from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import Loader from "../Loader/Loader";

const LoadablePayments = lazy(() => import("./PaymentsRoutes"));
const LoadableSubscriptionHistory = lazy(() => import("./SubscriptionHistory/SubscriptionHistory"));

class billingPageRoute extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div id="mainContent" className={`${"mainContent"} ${this.props.sidebarExpanded ? "sidebar-expanded" : "sidebar-collapsed"}`}>
                <Suspense fallback={<Loader />}>
                    <Switch>
                        <Route path="/billing/history" component={LoadableSubscriptionHistory} />
                        <Route path="/billing" component={LoadablePayments} />
                    </Switch>
                </Suspense>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    sidebarExpanded: state.globalReducer.sidebarExpanded,
});

export default connect(mapStateToProps)(billingPageRoute);
